package app.nestbridge.app.di

import app.nestbridge.app.App
import app.nestbridge.app.context.identity.DefaultUserContextProvider
import app.nestbridge.app.context.identity.UserContextProvider
import app.nestbridge.app.presenter.AppPresenter
import app.nestbridge.app.presenter.AppPresenterFactory
import app.nestbridge.app.ui.AppUiFactory
import app.nestbridge.app.ui.AuthenticationUiFactory
import app.nestbridge.app.ui.OtpVerificationUiFactory
import app.nestbridge.app.usecase.ClearUserContextUseCase
import app.nestbridge.app.usecase.GetUserContextUseCase
import app.nestbridge.app.usecase.LoadUserContextUseCase
import app.nestbridge.app.usecase.LogoutUseCase
import app.nestbridge.app.usecase.ObserveAuthSessionUseCase
import app.nestbridge.app.usecase.PasskeyEnrollmentPromptUseCase
import app.nestbridge.app.usecase.ReadAuthSessionUseCase
import app.nestbridge.app.usecase.RenewSessionUseCase
import app.nestbridge.app.usecase.SetUserContextUseCase
import app.nestbridge.domain.identity.api.RemoteProfessionalProfileApiClient
import app.nestbridge.domain.identity.api.RemoteUserApiClient
import app.nestbridge.domain.identity.api.RemoteUserProfileApiClient
import app.nestbridge.domain.identity.service.DefaultProfessionalProfileService
import app.nestbridge.domain.identity.service.DefaultUserProfileService
import app.nestbridge.domain.identity.service.DefaultUserService
import app.nestbridge.domain.identity.service.ProfessionalProfileService
import app.nestbridge.domain.identity.service.UserProfileService
import app.nestbridge.domain.identity.service.UserService
import app.nestbridge.domain.identity.usecase.GetCurrentProfessionalProfileUseCase
import app.nestbridge.domain.identity.usecase.GetCurrentUserProfileUseCase
import app.nestbridge.domain.identity.usecase.GetCurrentUserUseCase
import app.nestbridge.domain.identity.usecase.SaveProfessionalProfileUseCase
import app.nestbridge.domain.identity.usecase.SaveUserProfileUseCase
import app.nestbridge.domain.identity.usecase.SaveUserUseCase
import app.nestbridge.domain.ping.api.RemotePingApiClient
import app.nestbridge.domain.ping.service.DefaultPingService
import app.nestbridge.domain.ping.usecase.PingUseCase
import app.nestbridge.feature.careteam.api.RemoteCareTeamApiClient
import app.nestbridge.feature.careteam.presentation.CreateCareTeamPresenter
import app.nestbridge.feature.careteam.presentation.CreateCareTeamPresenterFactory
import app.nestbridge.feature.careteam.service.CareTeamService
import app.nestbridge.feature.careteam.service.DefaultCareTeamService
import app.nestbridge.feature.careteam.ui.CreateCareTeamUiFactory
import app.nestbridge.feature.careteam.usecase.FindAllCareTeamsUseCase
import app.nestbridge.feature.careteam.usecase.FindCareTeamsByChildIdUseCase
import app.nestbridge.feature.careteam.usecase.SaveCareTeamUseCase
import app.nestbridge.feature.children.api.RemoteChildApiClient
import app.nestbridge.feature.children.presentation.ChildDetailPresenter
import app.nestbridge.feature.children.presentation.ChildDetailPresenterFactory
import app.nestbridge.feature.children.presentation.ChildListPresenter
import app.nestbridge.feature.children.presentation.ChildListPresenterFactory
import app.nestbridge.feature.children.presentation.ChildrenPresenter
import app.nestbridge.feature.children.presentation.ChildrenPresenterFactory
import app.nestbridge.feature.children.presentation.CreateChildProfilePresenter
import app.nestbridge.feature.children.presentation.CreateChildProfilePresenterFactory
import app.nestbridge.feature.children.service.ChildService
import app.nestbridge.feature.children.service.DefaultChildService
import app.nestbridge.feature.children.ui.ChildDetailUiFactory
import app.nestbridge.feature.children.ui.ChildListUiFactory
import app.nestbridge.feature.children.ui.ChildrenUiFactory
import app.nestbridge.feature.children.ui.CreateChildProfileUiFactory
import app.nestbridge.feature.children.usecase.FindAllChildrenUseCase
import app.nestbridge.feature.children.usecase.GetChildUseCase
import app.nestbridge.feature.children.usecase.SaveChildUseCase
import app.nestbridge.feature.common.presentation.DocumentViewerPresenter
import app.nestbridge.feature.common.presentation.DocumentViewerPresenterFactory
import app.nestbridge.feature.common.ui.DocumentUiFactory
import app.nestbridge.feature.designcatalog.presentation.DesignCatalogPresenter
import app.nestbridge.feature.designcatalog.presentation.DesignCatalogPresenterFactory
import app.nestbridge.feature.designcatalog.ui.DesignCatalogUiFactory
import app.nestbridge.feature.home.presentation.HomePresenter
import app.nestbridge.feature.home.presentation.HomePresenterFactory
import app.nestbridge.feature.home.ui.HomeUiFactory
import app.nestbridge.feature.invitations.api.RemoteInvitationApiClient
import app.nestbridge.feature.invitations.presentation.InvitationConfirmationPresenter
import app.nestbridge.feature.invitations.presentation.InvitationConfirmationPresenterFactory
import app.nestbridge.feature.invitations.presentation.InvitationDetailPresenter
import app.nestbridge.feature.invitations.presentation.InvitationDetailPresenterFactory
import app.nestbridge.feature.invitations.presentation.InvitationListPresenter
import app.nestbridge.feature.invitations.presentation.InvitationListPresenterFactory
import app.nestbridge.feature.invitations.presentation.InvitationOtpVerificationPresenter
import app.nestbridge.feature.invitations.presentation.InvitationOtpVerificationPresenterFactory
import app.nestbridge.feature.invitations.presentation.InvitationQrScanPresenter
import app.nestbridge.feature.invitations.presentation.InvitationQrScanPresenterFactory
import app.nestbridge.feature.invitations.presentation.SendInvitationPresenter
import app.nestbridge.feature.invitations.presentation.SendInvitationPresenterFactory
import app.nestbridge.feature.invitations.presentation.ShowInvitationQRCodePresenter
import app.nestbridge.feature.invitations.presentation.ShowInvitationQRCodePresenterFactory
import app.nestbridge.feature.invitations.service.DefaultInvitationService
import app.nestbridge.feature.invitations.service.DefaultTeamMembershipUpdater
import app.nestbridge.feature.invitations.service.InvitationService
import app.nestbridge.feature.invitations.ui.InvitationConfirmationUiFactory
import app.nestbridge.feature.invitations.ui.InvitationDetailUiFactory
import app.nestbridge.feature.invitations.ui.InvitationListUiFactory
import app.nestbridge.feature.invitations.ui.InvitationOtpVerificationUiFactory
import app.nestbridge.feature.invitations.ui.InvitationQrScanUiFactory
import app.nestbridge.feature.invitations.ui.SendInvitationUiFactory
import app.nestbridge.feature.invitations.ui.ShowInvitationQRCodeUiFactory
import app.nestbridge.feature.invitations.usecase.AcceptInvitationUseCase
import app.nestbridge.feature.invitations.usecase.AcceptInvitationWithVerificationUseCase
import app.nestbridge.feature.invitations.usecase.CreateInvitationUseCase
import app.nestbridge.feature.invitations.usecase.DeclineInvitationUseCase
import app.nestbridge.feature.invitations.usecase.FindInvitationByClaimTokenUseCase
import app.nestbridge.feature.invitations.usecase.FindInvitationByIdUseCase
import app.nestbridge.feature.invitations.usecase.FindReceivedInvitationsUseCase
import app.nestbridge.feature.invitations.usecase.GetPendingTeamCreationInvitationUseCase
import app.nestbridge.feature.invitations.usecase.InitiateInvitationVerificationUseCase
import app.nestbridge.feature.invitations.usecase.RescindInvitationUseCase
import app.nestbridge.feature.main.presentation.MainShellPresenter
import app.nestbridge.feature.main.presentation.MainShellPresenterFactory
import app.nestbridge.feature.main.ui.MainShellUiFactory
import app.nestbridge.feature.messages.presentation.MessagesPresenter
import app.nestbridge.feature.messages.presentation.MessagesPresenterFactory
import app.nestbridge.feature.messages.ui.MessagesUiFactory
import app.nestbridge.feature.profile.presentation.CreateProfessionalProfilePresenter
import app.nestbridge.feature.profile.presentation.CreateProfessionalProfilePresenterFactory
import app.nestbridge.feature.profile.presentation.CreateUserProfilePresenter
import app.nestbridge.feature.profile.presentation.CreateUserProfilePresenterFactory
import app.nestbridge.feature.profile.presentation.ProfilePresenter
import app.nestbridge.feature.profile.presentation.ProfilePresenterFactory
import app.nestbridge.feature.profile.ui.CreateProfessionalProfileUiFactory
import app.nestbridge.feature.profile.ui.CreateUserProfileUiFactory
import app.nestbridge.feature.profile.ui.ProfileUiFactory
import app.nestbridge.feature.progress.presentation.ProgressPresenter
import app.nestbridge.feature.progress.presentation.ProgressPresenterFactory
import app.nestbridge.feature.progress.ui.ProgressUiFactory
import com.karawek.core.auth.`internal`.DefaultAuthSessionManager
import com.karawek.core.auth.`internal`.DefaultAuthSessionStore
import com.karawek.core.auth.api.AuthSessionStore
import com.karawek.core.auth.api.Authenticator
import com.karawek.core.auth.presenter.AuthenticationPresenter
import com.karawek.core.auth.presenter.AuthenticationPresenterFactory
import com.karawek.core.auth.presenter.OtpVerificationPresenter
import com.karawek.core.auth.presenter.OtpVerificationPresenterFactory
import com.karawek.core.auth.stytch.client.StytchClient
import com.karawek.core.auth.usecase.AuthenticateWithNativeUseCase
import com.karawek.core.auth.usecase.AuthenticateWithOAuthUseCase
import com.karawek.core.auth.usecase.AuthenticateWithPasskeyUseCase
import com.karawek.core.auth.usecase.GetAvailableAuthMethodsUseCase
import com.karawek.core.auth.usecase.InitiateOtpUseCase
import com.karawek.core.auth.usecase.RegisterPasskeyUseCase
import com.karawek.core.auth.usecase.SaveAuthSessionUseCase
import com.karawek.core.auth.usecase.VerifyOtpUseCase
import com.karawek.core.auth.util.AuthNavigationUtils
import com.karawek.core.platform.PlatformContext
import com.slack.circuit.foundation.Circuit
import io.ktor.client.HttpClient
import kotlin.reflect.KClass
import me.tatarka.inject.`internal`.LazyMap
import me.tatarka.inject.`internal`.ScopedComponent

public fun KClass<KotlinInjectAppComponent>.create(platformContextDelegate: PlatformContext): KotlinInjectAppComponent = InjectKotlinInjectAppComponent(platformContextDelegate)

public class InjectKotlinInjectAppComponent(
  platformContextDelegate: PlatformContext,
) : KotlinInjectAppComponent(platformContextDelegate),
    ScopedComponent {
  override val _scoped: LazyMap = LazyMap()

  private val readAuthSessionUseCase: ReadAuthSessionUseCase
    get() = ReadAuthSessionUseCase(
      authSessionStore = authSessionStore
    )

  private val authSessionStore: AuthSessionStore
    get() = provideDefaultAuthSessionStoreAuthSessionStore(
      defaultAuthSessionStore = _scoped.get("com.karawek.core.auth.`internal`.DefaultAuthSessionStore") {
        DefaultAuthSessionStore(
          secureStorage = _scoped.get("@AuthSessionStorage" + "com.karawek.core.platform.SecureStorage") {
            provideAuthSessionStore(
              context = platformContext
            )
          }
        )
      }
    )

  private val platformContext: PlatformContext
    get() = _scoped.get("com.karawek.core.platform.PlatformContext") {
      providePlatformContext()
    }

  private val userContextProvider: UserContextProvider
    get() = provideDefaultUserContextProviderUserContextProvider(
      defaultUserContextProvider = _scoped.get("app.nestbridge.app.context.identity.DefaultUserContextProvider") {
        DefaultUserContextProvider()
      }
    )

  private val userService: UserService
    get() = provideDefaultUserServiceUserService(
      defaultUserService = _scoped.get("app.nestbridge.domain.identity.service.DefaultUserService") {
        DefaultUserService(
          apiClient = provideRemoteUserApiClientUserApiClient(
            remoteUserApiClient = _scoped.get("app.nestbridge.domain.identity.api.RemoteUserApiClient") {
              RemoteUserApiClient(
                httpClient = httpClient,
                config = clientApiConfig
              )
            }
          )
        )
      }
    )

  private val httpClient: HttpClient
    get() = _scoped.get("io.ktor.client.HttpClient") {
      provideHttpClient(
        authSessionManager = provideDefaultAuthSessionManagerAuthSessionManager(
          defaultAuthSessionManager = _scoped.get("com.karawek.core.auth.`internal`.DefaultAuthSessionManager") {
            DefaultAuthSessionManager(
              tokenProvider = _scoped.get("com.karawek.core.auth.api.AuthTokenProvider") {
                provideAuthTokenProvider(
                  stytchClient = stytchClient
                )
              },
              sessionStore = authSessionStore
            )
          }
        )
      )
    }

  private val stytchClient: StytchClient?
    get() = _scoped.get("com.karawek.core.auth.stytch.client.StytchClient?") {
      provideStytchClient(
        platformContext = platformContext,
        config = _scoped.get("com.karawek.core.auth.stytch.config.StytchConfig") {
          provideStytchConfig()
        },
        useLocalAuthenticator = _scoped.get("@UseLocalAuthenticator" + "kotlin.Boolean") {
          provideUseLocalAuthenticator()
        }
      )
    }

  private val clientApiConfig: ClientApiConfig
    get() = _scoped.get("app.nestbridge.app.di.ClientApiConfig") {
      provideClientApiConfig()
    }

  private val userProfileService: UserProfileService
    get() = provideDefaultUserProfileServiceUserProfileService(
      defaultUserProfileService = _scoped.get("app.nestbridge.domain.identity.service.DefaultUserProfileService") {
        DefaultUserProfileService(
          apiClient = provideRemoteUserProfileApiClientUserProfileApiClient(
            remoteUserProfileApiClient = _scoped.get("app.nestbridge.domain.identity.api.RemoteUserProfileApiClient") {
              RemoteUserProfileApiClient(
                httpClient = httpClient,
                config = clientApiConfig
              )
            }
          )
        )
      }
    )

  private val professionalProfileService: ProfessionalProfileService
    get() = provideDefaultProfessionalProfileServiceProfessionalProfileService(
      defaultProfessionalProfileService = _scoped.get("app.nestbridge.domain.identity.service.DefaultProfessionalProfileService") {
        DefaultProfessionalProfileService(
          apiClient = provideRemoteProfessionalProfileApiClientProfessionalProfileApiClient(
            remoteProfessionalProfileApiClient = _scoped.get("app.nestbridge.domain.identity.api.RemoteProfessionalProfileApiClient") {
              RemoteProfessionalProfileApiClient(
                httpClient = httpClient,
                config = clientApiConfig
              )
            }
          )
        )
      }
    )

  private val getUserContextUseCase: GetUserContextUseCase
    get() = GetUserContextUseCase(
      userContextProvider = userContextProvider
    )

  private val setUserContextUseCase: SetUserContextUseCase
    get() = SetUserContextUseCase(
      userContextProvider = userContextProvider
    )

  private val logoutUseCase: LogoutUseCase
    get() = LogoutUseCase(
      authNavigationUtils = _scoped.get("com.karawek.core.auth.util.AuthNavigationUtils") {
        AuthNavigationUtils(
          authenticator = authenticator,
          sessionStore = authSessionStore
        )
      }
    )

  private val authenticator: Authenticator
    get() = _scoped.get("com.karawek.core.auth.api.Authenticator") {
      provideAuthenticator(
        stytchClient = stytchClient
      )
    }

  private val registerPasskeyUseCase: RegisterPasskeyUseCase
    get() = _scoped.get("com.karawek.core.auth.usecase.RegisterPasskeyUseCase") {
      RegisterPasskeyUseCase(
        authenticator = authenticator
      )
    }

  private val getAvailableAuthMethodsUseCase: GetAvailableAuthMethodsUseCase
    get() = _scoped.get("com.karawek.core.auth.usecase.GetAvailableAuthMethodsUseCase") {
      GetAvailableAuthMethodsUseCase(
        authenticator = authenticator
      )
    }

  private val passkeyEnrollmentPromptUseCase: PasskeyEnrollmentPromptUseCase
    get() = _scoped.get("app.nestbridge.app.usecase.PasskeyEnrollmentPromptUseCase") {
      PasskeyEnrollmentPromptUseCase(
        getAvailableAuthMethods = getAvailableAuthMethodsUseCase,
        settings = _scoped.get("com.russhwolf.settings.coroutines.SuspendSettings") {
          provideSuspendSettings(
            context = platformContext
          )
        }
      )
    }

  private val careTeamService: CareTeamService
    get() = provideDefaultCareTeamServiceCareTeamService(
      defaultCareTeamService = _scoped.get("app.nestbridge.feature.careteam.service.DefaultCareTeamService") {
        DefaultCareTeamService(
          apiClient = provideRemoteCareTeamApiClientCareTeamApiClient(
            remoteCareTeamApiClient = _scoped.get("app.nestbridge.feature.careteam.api.RemoteCareTeamApiClient") {
              RemoteCareTeamApiClient(
                httpClient = httpClient,
                config = clientApiConfig
              )
            }
          )
        )
      }
    )

  private val getChildUseCase: GetChildUseCase
    get() = GetChildUseCase(
      childService = childService
    )

  private val childService: ChildService
    get() = provideDefaultChildServiceChildService(
      defaultChildService = _scoped.get("app.nestbridge.feature.children.service.DefaultChildService") {
        DefaultChildService(
          apiClient = provideRemoteChildApiClientChildApiClient(
            remoteChildApiClient = _scoped.get("app.nestbridge.feature.children.api.RemoteChildApiClient") {
              RemoteChildApiClient(
                httpClient = httpClient,
                config = clientApiConfig
              )
            }
          )
        )
      }
    )

  private val getCurrentUserUseCase: GetCurrentUserUseCase
    get() = GetCurrentUserUseCase(
      userService = userService
    )

  private val findAllCareTeamsUseCase: FindAllCareTeamsUseCase
    get() = FindAllCareTeamsUseCase(
      careTeamService = careTeamService
    )

  private val findCareTeamsByChildIdUseCase: FindCareTeamsByChildIdUseCase
    get() = FindCareTeamsByChildIdUseCase(
      careTeamService = careTeamService
    )

  private val getPendingTeamCreationInvitationUseCase: GetPendingTeamCreationInvitationUseCase
    get() = GetPendingTeamCreationInvitationUseCase(
      invitationService = invitationService
    )

  private val invitationService: InvitationService
    get() = provideDefaultInvitationServiceInvitationService(
      defaultInvitationService = _scoped.get("app.nestbridge.feature.invitations.service.DefaultInvitationService") {
        DefaultInvitationService(
          apiClient = provideRemoteInvitationApiClientInvitationApiClient(
            remoteInvitationApiClient = _scoped.get("app.nestbridge.feature.invitations.api.RemoteInvitationApiClient") {
              RemoteInvitationApiClient(
                httpClient = httpClient,
                config = clientApiConfig
              )
            }
          ),
          teamMembershipUpdater = provideDefaultTeamMembershipUpdaterTeamMembershipUpdater(
            defaultTeamMembershipUpdater = _scoped.get("app.nestbridge.feature.invitations.service.DefaultTeamMembershipUpdater") {
              DefaultTeamMembershipUpdater(
                careTeamService = careTeamService,
                getCurrentUserUseCase = getCurrentUserUseCase
              )
            }
          )
        )
      }
    )

  private val acceptInvitationUseCase: AcceptInvitationUseCase
    get() = AcceptInvitationUseCase(
      invitationService = invitationService
    )

  private val declineInvitationUseCase: DeclineInvitationUseCase
    get() = DeclineInvitationUseCase(
      invitationService = invitationService
    )

  private val findInvitationByClaimTokenUseCase: FindInvitationByClaimTokenUseCase
    get() = FindInvitationByClaimTokenUseCase(
      invitationService = invitationService
    )

  private val saveAuthSessionUseCase: SaveAuthSessionUseCase
    get() = _scoped.get("com.karawek.core.auth.usecase.SaveAuthSessionUseCase") {
      SaveAuthSessionUseCase(
        sessionStore = authSessionStore
      )
    }

  override val rootApp: App
    get() = {
      app.nestbridge.app.App(
        circuit = circuit,
        observeAuthSessionUseCase = ObserveAuthSessionUseCase(
          authSessionStore = authSessionStore
        ),
        logoutUseCase = logoutUseCase,
        renewSessionUseCase = RenewSessionUseCase(
          authenticator = authenticator
        ),
        registerPasskeyUseCase = registerPasskeyUseCase,
        passkeyEnrollmentPrompt = passkeyEnrollmentPromptUseCase
      )
    }

  override val circuit: Circuit
    get() = _scoped.get("com.slack.circuit.foundation.Circuit") {
      provideCircuit(
        presenterFactories = setOf(
          provideAppPresenterFactoryFactoryMultibinding(
            appPresenterFactory = AppPresenterFactory(
              factory = { arg0 ->
                AppPresenter(
                  navigator = arg0,
                  readAuthSessionUseCase = readAuthSessionUseCase,
                  loadUserContextUseCase = LoadUserContextUseCase(
                    userContextProvider = userContextProvider,
                    userService = userService,
                    userProfileService = userProfileService,
                    professionalProfileService = professionalProfileService
                  )
                )
              }
            )
          ),
          provideHomePresenterFactoryFactoryMultibinding(
            homePresenterFactory = HomePresenterFactory(
              provider = {
                HomePresenter()
              }
            )
          ),
          provideMessagesPresenterFactoryFactoryMultibinding(
            messagesPresenterFactory = MessagesPresenterFactory(
              provider = {
                MessagesPresenter()
              }
            )
          ),
          provideProgressPresenterFactoryFactoryMultibinding(
            progressPresenterFactory = ProgressPresenterFactory(
              provider = {
                ProgressPresenter()
              }
            )
          ),
          provideDesignCatalogPresenterFactoryFactoryMultibinding(
            designCatalogPresenterFactory = DesignCatalogPresenterFactory(
              factory = { arg0 ->
                DesignCatalogPresenter(
                  navigator = arg0
                )
              }
            )
          ),
          provideDocumentViewerPresenterFactoryFactoryMultibinding(
            documentViewerPresenterFactory = DocumentViewerPresenterFactory(
              factory = { arg0, arg1 ->
                DocumentViewerPresenter(
                  screen = arg0,
                  navigator = arg1
                )
              }
            )
          ),
          provideCreateUserProfilePresenterFactoryFactoryMultibinding(
            createUserProfilePresenterFactory = CreateUserProfilePresenterFactory(
              factory = { arg0, arg1 ->
                CreateUserProfilePresenter(
                  screen = arg0,
                  navigator = arg1,
                  readAuthSessionUseCase = readAuthSessionUseCase,
                  getUserContextUseCase = getUserContextUseCase,
                  setUserContextUseCase = setUserContextUseCase,
                  saveUserUseCase = SaveUserUseCase(
                    userService = userService
                  ),
                  saveUserProfileUseCase = SaveUserProfileUseCase(
                    userProfileService = userProfileService
                  )
                )
              }
            )
          ),
          provideProfilePresenterFactoryFactoryMultibinding(
            profilePresenterFactory = ProfilePresenterFactory(
              factory = { arg0 ->
                ProfilePresenter(
                  navigator = arg0,
                  logoutUseCase = logoutUseCase,
                  getUserContextUseCase = getUserContextUseCase,
                  clearUserContextUseCase = ClearUserContextUseCase(
                    userContextProvider = userContextProvider
                  ),
                  pingUseCase = PingUseCase(
                    pingService = provideDefaultPingServicePingService(
                      defaultPingService = _scoped.get("app.nestbridge.domain.ping.service.DefaultPingService") {
                        DefaultPingService(
                          apiClient = provideRemotePingApiClientPingApiClient(
                            remotePingApiClient = _scoped.get("app.nestbridge.domain.ping.api.RemotePingApiClient") {
                              RemotePingApiClient(
                                httpClient = httpClient
                              )
                            }
                          )
                        )
                      }
                    )
                  ),
                  registerPasskeyUseCase = registerPasskeyUseCase,
                  getAvailableAuthMethods = getAvailableAuthMethodsUseCase,
                  passkeyEnrollmentPrompt = passkeyEnrollmentPromptUseCase
                )
              }
            )
          ),
          provideCreateProfessionalProfilePresenterFactoryFactoryMultibinding(
            createProfessionalProfilePresenterFactory = CreateProfessionalProfilePresenterFactory(
              factory = { arg0, arg1 ->
                CreateProfessionalProfilePresenter(
                  screen = arg0,
                  navigator = arg1,
                  getUserContextUseCase = getUserContextUseCase,
                  setUserContextUseCase = setUserContextUseCase,
                  readAuthSessionUseCase = readAuthSessionUseCase,
                  saveProfessionalProfileUseCase = SaveProfessionalProfileUseCase(
                    professionalProfileService = professionalProfileService
                  )
                )
              }
            )
          ),
          provideCreateCareTeamPresenterFactoryFactoryMultibinding(
            createCareTeamPresenterFactory = CreateCareTeamPresenterFactory(
              factory = { arg0, arg1 ->
                CreateCareTeamPresenter(
                  screen = arg0,
                  navigator = arg1,
                  saveCareTeamUseCase = SaveCareTeamUseCase(
                    careTeamService = careTeamService
                  ),
                  getChildUseCase = getChildUseCase,
                  getCurrentUserUseCase = getCurrentUserUseCase
                )
              }
            )
          ),
          provideChildrenPresenterFactoryFactoryMultibinding(
            childrenPresenterFactory = ChildrenPresenterFactory(
              provider = {
                ChildrenPresenter()
              }
            )
          ),
          provideCreateChildProfilePresenterFactoryFactoryMultibinding(
            createChildProfilePresenterFactory = CreateChildProfilePresenterFactory(
              factory = { arg0, arg1 ->
                CreateChildProfilePresenter(
                  screen = arg0,
                  navigator = arg1,
                  saveChildUseCase = SaveChildUseCase(
                    childService = childService
                  ),
                  getCurrentUserUseCase = getCurrentUserUseCase
                )
              }
            )
          ),
          provideChildListPresenterFactoryFactoryMultibinding(
            childListPresenterFactory = ChildListPresenterFactory(
              factory = { arg0 ->
                ChildListPresenter(
                  navigator = arg0,
                  findAllChildrenUseCase = FindAllChildrenUseCase(
                    childService = childService
                  ),
                  findAllCareTeamsUseCase = findAllCareTeamsUseCase,
                  findCareTeamsByChildIdUseCase = findCareTeamsByChildIdUseCase,
                  getPendingTeamCreationInvitationUseCase = getPendingTeamCreationInvitationUseCase,
                  getCurrentUserUseCase = getCurrentUserUseCase
                )
              }
            )
          ),
          provideChildDetailPresenterFactoryFactoryMultibinding(
            childDetailPresenterFactory = ChildDetailPresenterFactory(
              factory = { arg0, arg1 ->
                ChildDetailPresenter(
                  screen = arg0,
                  navigator = arg1,
                  getChildUseCase = getChildUseCase,
                  findCareTeamsByChildIdUseCase = findCareTeamsByChildIdUseCase,
                  getPendingTeamCreationInvitationUseCase = getPendingTeamCreationInvitationUseCase,
                  rescindInvitationUseCase = RescindInvitationUseCase(
                    invitationService = invitationService
                  ),
                  getCurrentProfessionalProfileUseCase = GetCurrentProfessionalProfileUseCase(
                    professionalProfileService = professionalProfileService
                  )
                )
              }
            )
          ),
          provideMainShellPresenterFactoryFactoryMultibinding(
            mainShellPresenterFactory = MainShellPresenterFactory(
              factory = { arg0 ->
                MainShellPresenter(
                  navigator = arg0,
                  getUserContextUseCase = getUserContextUseCase
                )
              }
            )
          ),
          provideInvitationConfirmationPresenterFactoryFactoryMultibinding(
            invitationConfirmationPresenterFactory = InvitationConfirmationPresenterFactory(
              factory = { arg0, arg1 ->
                InvitationConfirmationPresenter(
                  navigator = arg0,
                  screen = arg1
                )
              }
            )
          ),
          provideInvitationOtpVerificationPresenterFactoryFactoryMultibinding(
            invitationOtpVerificationPresenterFactory = InvitationOtpVerificationPresenterFactory(
              factory = { arg0, arg1 ->
                InvitationOtpVerificationPresenter(
                  screen = arg0,
                  navigator = arg1,
                  initiateInvitationVerification = InitiateInvitationVerificationUseCase(
                    invitationService = invitationService
                  ),
                  acceptInvitationWithVerification = AcceptInvitationWithVerificationUseCase(
                    invitationService = invitationService
                  )
                )
              }
            )
          ),
          provideInvitationListPresenterFactoryFactoryMultibinding(
            invitationListPresenterFactory = InvitationListPresenterFactory(
              factory = { arg0, arg1 ->
                InvitationListPresenter(
                  screen = arg0,
                  navigator = arg1,
                  findReceivedInvitationsUseCase = FindReceivedInvitationsUseCase(
                    invitationService = invitationService
                  ),
                  acceptInvitationUseCase = acceptInvitationUseCase,
                  declineInvitationUseCase = declineInvitationUseCase,
                  findAllCareTeamsUseCase = findAllCareTeamsUseCase,
                  getCurrentUserUseCase = getCurrentUserUseCase
                )
              }
            )
          ),
          provideInvitationDetailPresenterFactoryFactoryMultibinding(
            invitationDetailPresenterFactory = InvitationDetailPresenterFactory(
              factory = { arg0, arg1 ->
                InvitationDetailPresenter(
                  navigator = arg0,
                  screen = arg1,
                  userContextProvider = userContextProvider,
                  findInvitationByIdUseCase = FindInvitationByIdUseCase(
                    invitationService = invitationService
                  ),
                  acceptInvitationUseCase = acceptInvitationUseCase,
                  declineInvitationUseCase = declineInvitationUseCase
                )
              }
            )
          ),
          provideInvitationQrScanPresenterFactoryFactoryMultibinding(
            invitationQrScanPresenterFactory = InvitationQrScanPresenterFactory(
              factory = { arg0 ->
                InvitationQrScanPresenter(
                  navigator = arg0,
                  findInvitationByClaimTokenUseCase = findInvitationByClaimTokenUseCase
                )
              }
            )
          ),
          provideSendInvitationPresenterFactoryFactoryMultibinding(
            sendInvitationPresenterFactory = SendInvitationPresenterFactory(
              factory = { arg0, arg1 ->
                SendInvitationPresenter(
                  screen = arg0,
                  navigator = arg1,
                  getChildUseCase = getChildUseCase,
                  createInvitationUseCase = CreateInvitationUseCase(
                    invitationService = invitationService
                  ),
                  getCurrentUserUseCase = getCurrentUserUseCase,
                  getCurrentUserProfileUseCase = GetCurrentUserProfileUseCase(
                    userProfileService = userProfileService
                  )
                )
              }
            )
          ),
          provideShowInvitationQRCodePresenterFactoryFactoryMultibinding(
            showInvitationQRCodePresenterFactory = ShowInvitationQRCodePresenterFactory(
              factory = { arg0, arg1 ->
                ShowInvitationQRCodePresenter(
                  screen = arg0,
                  navigator = arg1,
                  findInvitationByClaimTokenUseCase = findInvitationByClaimTokenUseCase
                )
              }
            )
          ),
          provideAuthenticationPresenterFactoryFactoryMultibinding(
            authenticationPresenterFactory = AuthenticationPresenterFactory(
              factory = { arg0, arg1 ->
                AuthenticationPresenter(
                  screen = arg0,
                  navigator = arg1,
                  saveAuthSession = saveAuthSessionUseCase,
                  getAvailableAuthMethods = getAvailableAuthMethodsUseCase,
                  authenticateWithOAuth = _scoped.get("com.karawek.core.auth.usecase.AuthenticateWithOAuthUseCase") {
                    AuthenticateWithOAuthUseCase(
                      authenticator = authenticator
                    )
                  },
                  authenticateWithNative = _scoped.get("com.karawek.core.auth.usecase.AuthenticateWithNativeUseCase") {
                    AuthenticateWithNativeUseCase(
                      authenticator = authenticator
                    )
                  },
                  authenticateWithPasskey = _scoped.get("com.karawek.core.auth.usecase.AuthenticateWithPasskeyUseCase") {
                    AuthenticateWithPasskeyUseCase(
                      authenticator = authenticator
                    )
                  }
                )
              }
            )
          ),
          provideOtpVerificationPresenterFactoryFactoryMultibinding(
            otpVerificationPresenterFactory = OtpVerificationPresenterFactory(
              factory = { arg0, arg1 ->
                OtpVerificationPresenter(
                  screen = arg0,
                  navigator = arg1,
                  initiateOtp = _scoped.get("com.karawek.core.auth.usecase.InitiateOtpUseCase") {
                    InitiateOtpUseCase(
                      authenticator = authenticator
                    )
                  },
                  verifyOtp = _scoped.get("com.karawek.core.auth.usecase.VerifyOtpUseCase") {
                    VerifyOtpUseCase(
                      authenticator = authenticator
                    )
                  },
                  saveAuthSession = saveAuthSessionUseCase
                )
              }
            )
          )
        ),
        uiFactories = setOf(
          provideOtpVerificationUiFactoryFactoryMultibinding(
            otpVerificationUiFactory = OtpVerificationUiFactory()
          ),
          provideAppUiFactoryFactoryMultibinding(
            appUiFactory = AppUiFactory()
          ),
          provideAuthenticationUiFactoryFactoryMultibinding(
            authenticationUiFactory = AuthenticationUiFactory()
          ),
          provideHomeUiFactoryFactoryMultibinding(
            homeUiFactory = HomeUiFactory()
          ),
          provideMessagesUiFactoryFactoryMultibinding(
            messagesUiFactory = MessagesUiFactory()
          ),
          provideProgressUiFactoryFactoryMultibinding(
            progressUiFactory = ProgressUiFactory()
          ),
          provideDesignCatalogUiFactoryFactoryMultibinding(
            designCatalogUiFactory = DesignCatalogUiFactory()
          ),
          provideDocumentUiFactoryFactoryMultibinding(
            documentUiFactory = DocumentUiFactory()
          ),
          provideCreateProfessionalProfileUiFactoryFactoryMultibinding(
            createProfessionalProfileUiFactory = CreateProfessionalProfileUiFactory()
          ),
          provideCreateUserProfileUiFactoryFactoryMultibinding(
            createUserProfileUiFactory = CreateUserProfileUiFactory()
          ),
          provideProfileUiFactoryFactoryMultibinding(
            profileUiFactory = ProfileUiFactory()
          ),
          provideCreateCareTeamUiFactoryFactoryMultibinding(
            createCareTeamUiFactory = CreateCareTeamUiFactory()
          ),
          provideChildListUiFactoryFactoryMultibinding(
            childListUiFactory = ChildListUiFactory()
          ),
          provideCreateChildProfileUiFactoryFactoryMultibinding(
            createChildProfileUiFactory = CreateChildProfileUiFactory()
          ),
          provideChildDetailUiFactoryFactoryMultibinding(
            childDetailUiFactory = ChildDetailUiFactory()
          ),
          provideChildrenUiFactoryFactoryMultibinding(
            childrenUiFactory = ChildrenUiFactory()
          ),
          provideMainShellUiFactoryFactoryMultibinding(
            mainShellUiFactory = MainShellUiFactory()
          ),
          provideSendInvitationUiFactoryFactoryMultibinding(
            sendInvitationUiFactory = SendInvitationUiFactory()
          ),
          provideInvitationListUiFactoryFactoryMultibinding(
            invitationListUiFactory = InvitationListUiFactory()
          ),
          provideInvitationConfirmationUiFactoryFactoryMultibinding(
            invitationConfirmationUiFactory = InvitationConfirmationUiFactory()
          ),
          provideInvitationOtpVerificationUiFactoryFactoryMultibinding(
            invitationOtpVerificationUiFactory = InvitationOtpVerificationUiFactory()
          ),
          provideInvitationQrScanUiFactoryFactoryMultibinding(
            invitationQrScanUiFactory = InvitationQrScanUiFactory()
          ),
          provideInvitationDetailUiFactoryFactoryMultibinding(
            invitationDetailUiFactory = InvitationDetailUiFactory()
          ),
          provideShowInvitationQRCodeUiFactoryFactoryMultibinding(
            showInvitationQRCodeUiFactory = ShowInvitationQRCodeUiFactory()
          )
        )
      )
    }
}
